import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check, Mail, Calendar } from "lucide-react";

const CourseSuccess = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    // Scroll to top on load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-ink pt-32 pb-20">
      <div className="max-w-2xl mx-auto px-6 lg:px-8 text-center">
        {/* Success Icon */}
        <div className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-8">
          <Check className="w-10 h-10 text-green-500" />
        </div>

        <h1 className="font-heading text-4xl md:text-5xl text-[#EAEAEA] mb-6">
          You're In!
        </h1>

        <p className="text-[#A1A1AA] text-lg mb-8 leading-relaxed">
          Thank you for enrolling in <span className="text-gold">Nervous System Foundations</span>. 
          You've just taken a meaningful step toward building real stability in your body and life.
        </p>

        {/* What's Next */}
        <div className="bg-paper border border-white/5 p-8 rounded-sm text-left mb-8">
          <h2 className="font-heading text-xl text-[#EAEAEA] mb-6">What happens next:</h2>
          
          <div className="space-y-6">
            <div className="flex gap-4">
              <div className="flex-shrink-0 w-10 h-10 bg-gold/10 rounded-full flex items-center justify-center">
                <Mail className="w-5 h-5 text-gold" />
              </div>
              <div>
                <h3 className="text-[#EAEAEA] font-medium mb-1">Check your inbox</h3>
                <p className="text-[#A1A1AA] text-sm">
                  A confirmation email is on its way with your receipt and next steps.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="flex-shrink-0 w-10 h-10 bg-gold/10 rounded-full flex items-center justify-center">
                <Calendar className="w-5 h-5 text-gold" />
              </div>
              <div>
                <h3 className="text-[#EAEAEA] font-medium mb-1">Save the date</h3>
                <p className="text-[#A1A1AA] text-sm">
                  We begin <strong>Wednesday, April 8th at 6:00pm AEST</strong>. 
                  I'll send you the Zoom link and preparation instructions before we start.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <Link
            to="/"
            className="inline-block bg-gold text-void font-body font-semibold uppercase tracking-widest py-4 px-10 rounded-sm hover:bg-gold/90 transition-colors"
          >
            Return Home
          </Link>
          
          <p className="text-[#666] text-sm">
            Questions? Email <a href="mailto:hello@somalume.org" className="text-gold hover:underline">hello@somalume.org</a>
          </p>
        </div>

        {sessionId && (
          <p className="mt-8 text-[#666] text-xs">
            Reference: {sessionId.slice(0, 20)}...
          </p>
        )}
      </div>
    </div>
  );
};

export default CourseSuccess;
